import { useState, useEffect, useCallback } from 'react';
import { useServices } from '@/app/providers';
import type { EmergencyContact, PanicAlertRequest, PanicAlertResponse } from '@yawi/types';

export function useEmergency() {
  const { guardRepo } = useServices();
  const [contacts, setContacts] = useState<EmergencyContact[]>([]);
  const [loading, setLoading] = useState(true);
  const [alertLoading, setAlertLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [lastAlert, setLastAlert] = useState<PanicAlertResponse | null>(null);

  const fetchContacts = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await guardRepo.getEmergencyContacts();
      setContacts(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al cargar contactos de emergencia');
    } finally {
      setLoading(false);
    }
  }, [guardRepo]);

  useEffect(() => {
    fetchContacts();
  }, [fetchContacts]);

  const triggerPanic = useCallback(async (request?: PanicAlertRequest) => {
    setAlertLoading(true);
    setError(null);
    try {
      const response = await guardRepo.triggerPanicAlert(request);
      setLastAlert(response);
      return response;
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Error al enviar alerta de pánico';
      setError(message);
      throw err;
    } finally {
      setAlertLoading(false);
    }
  }, [guardRepo]);

  return {
    contacts,
    loading,
    alertLoading,
    error,
    lastAlert,
    triggerPanic,
    refresh: fetchContacts,
  };
}
